import FlatSpinnerIcon from './FlatSpinnerIcon';
import ShadowSpinnerIcon from './ShadowSpinnerIcon';

const ICON_MAP = {
  shadow: ShadowSpinnerIcon,
  flat: FlatSpinnerIcon,
};

interface LoadingSpinnerProps {
  className?: string;
  variant?: 'shadow' | 'flat';
}

export default function LoadingSpinner({
  className = '',
  variant = 'shadow',
}: Readonly<LoadingSpinnerProps>) {
  const Icon = ICON_MAP[variant];

  return (
    <div className='text-center'>
      <div role='status'>
        <Icon className={className} />
        <span className='sr-only'>Loading...</span>
      </div>
    </div>
  );
}
